import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';
import {base64UrlDecode, REGEX_RANGE_FILTER, ROUTE_REGEX_BASE64_URL} from '../utils/portuna';
import dateHelper from '../utils/portuna/dateHelper';
import {timeTrackerMeta} from './time-tracker';

const VacationBlockList                    = () => import('../views/vacation/block/VacationBlockList.vue');
const VacationCompulsoryList               = () => import('../views/vacation/compulsory/VacationCompulsoryList.vue');
const VacationEntryList                    = () => import('../views/vacation/entry/VacationEntryList.vue');
const VacationStartValuesList              = () => import('../views/vacation/start-values/VacationStartValuesList.vue');
const VacationStartValuesImport            = () => import('../views/vacation/start-values/VacationStartValuesImport.vue');
const VacationAdditionalList               = () => import('../views/vacation/additional/VacationAdditionalList.vue');
const VacationRepresentationRegulationList = () => import('../views/vacation/representation-regulation/VacationRepresentationRegulationList.vue');
const VacationRepresentationRegulationView = () => import('../views/vacation/representation-regulation/VacationRepresentationRegulationView.vue');
const VacationStatisticList                = () => import('../views/vacation/statistic/VacationStatisticList.vue');
const VacationStatisticMonth               = () => import('../views/vacation/statistic/VacationStatisticMonth.vue');
let vacation: RouteRecordRaw[] = [
    {
        name: 'vacation',
        path: '/employee/vacation',
        redirect: {name: 'vacation-entry-list'},
    },
    //<editor-fold desc="vacation">
    {
        name: 'vacation-block-list',
        path: '/employee/vacation/block-list',
        component: VacationBlockList,
        meta: timeTrackerMeta,
    },
    {
        name: 'vacation-compulsory-list',
        path: '/employee/vacation/compulsory-list',
        component: VacationCompulsoryList,
        meta: timeTrackerMeta,
    },
    //</editor-fold>
    //<editor-fold desc="entry">
    {
        name: 'vacation-entry-list',
        path: '/employee/vacation/list/:type(all|mine)?/:search(' + ROUTE_REGEX_BASE64_URL + ')?/:range(' + REGEX_RANGE_FILTER + ')?',
        component: VacationEntryList,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                type: route.params.type ? route.params.type : 'mine',
                listSearch: route.params.search ? JSON.parse(base64UrlDecode(route.params.search)) : null,
                listRange: route.params.range || null,
            };
        },
    },
    {
        name: 'vacation-start-values-list',
        path: '/employee/vacation/start-values-list',
        component: VacationStartValuesList,
        meta: timeTrackerMeta,
    },
    {
        name: 'vacation-start-values-import',
        path: '/employee/vacation/start-values-import',
        component: VacationStartValuesImport,
        meta: timeTrackerMeta,
    },
    {
        name: 'vacation-additional-list',
        path: '/employee/vacation/additional-list',
        component: VacationAdditionalList,
        meta: timeTrackerMeta,
    },
    //</editor-fold>
    //<editor-fold desc="representation-regulation">
    {
        name: 'vacation-representation-regulation-list',
        path: '/employee/vacation/representation-regulation/list',
        component: VacationRepresentationRegulationList,
        meta: timeTrackerMeta,
    },
    {
        name: 'vacation-representation-regulation-view',
        path: '/employee/vacation/representation-regulation/view/:id',
        component: VacationRepresentationRegulationView,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
            };
        },
    },
    //</editor-fold>
    //<editor-fold desc="statistic">
    {
        name: 'vacation-statistic-list',
        path: '/employee/vacation/statistic/list/:year?',
        component: VacationStatisticList,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                year: route.params.year ? parseInt(route.params.year) : dateHelper('Y'),
            };
        },
    },
    {
        name: 'vacation-statistic-month',
        path: '/employee/vacation/statistic/month/:year?',
        component: VacationStatisticMonth,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                year: route.params.year ? parseInt(route.params.year) : dateHelper('Y'),
            };
        },
    },
    //</editor-fold>
    // COMPATIBILITY: OLD PATHS
    {
        path: '/employee/vacation/entry/list/mine/1',
        redirect: {
            name: 'vacation-entry-list',
            params: {type: 'mine'},
        },
    },
    {
        path: '/employee/vacation/entry/list/mine/0',
        redirect: {
            name: 'vacation-entry-list',
            params: {type: 'all'},
        },
    },
];

export default vacation;